/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Who_Wc3Inputs */

const en_wc_vs_who_wc3 = /** @type {(inputs: Wc_Vs_Who_Wc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`care about privacy and open source`)
};

/**
* | output |
* | --- |
* | "care about privacy and open source" |
*
* @param {Wc_Vs_Who_Wc3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_who_wc3 = /** @type {((inputs?: Wc_Vs_Who_Wc3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Who_Wc3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_who_wc3(inputs)
});
export { wc_vs_who_wc3 as "wc.vs.who_wc3" }